/**
 * Unity 메시지 큐 관리 모듈
 */

export type QueuedMessage = [string, string, string];

class UnityMessageQueue {
  private queue: QueuedMessage[] = [];
  private processing = false;

  /**
   * 메시지를 큐에 추가
   */
  enqueue(message: QueuedMessage): void {
    this.queue.push(message);
  }

  /**
   * 큐에서 메시지 제거
   */
  dequeue(): QueuedMessage | undefined {
    return this.queue.shift();
  }

  /**
   * 큐가 비어있는지 확인
   */
  isEmpty(): boolean {
    return this.queue.length === 0;
  }

  /**
   * 큐의 크기 반환
   */
  size(): number {
    return this.queue.length;
  }

  /**
   * 큐 비우기
   */
  clear(): void {
    this.queue = [];
  }

  /**
   * 처리 중인지 확인
   */
  isProcessing(): boolean {
    return this.processing;
  }

  /**
   * 처리 상태 설정
   */
  setProcessing(value: boolean): void {
    this.processing = value;
  }
}

export const unityMessageQueue = new UnityMessageQueue();

